import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const StripeBankConfirm = () => {
const navigate = useNavigate();

  useEffect(() => {
    // Animate success icon on mount
    const icon = document.querySelector('.success-icon');
    if (icon) {
      setTimeout(() => {
        icon.classList.add('animate');
      }, 100);
    }
  }, []);

  return (
    <div>
      {/* Background elements */}
      <div className="background"></div>
      <div className="orb orb1"></div>
      <div className="orb orb2"></div>
      
      {/* Navigation */}
      <nav id="navbar">
        <div className="nav-container">
            
        <div className="logo" onClick={() => navigate('/')}>
            <div className="logo-icon">
              <i className="fas fa-rocket"></i>
            </div>
            <span className="logo-text">Verca</span>
          </div>
        </div>
      </nav>

      {/* Confirmation Content */}
      <section className="confirmation-section">
        <div className="confirmation-card">
          <div className="success-icon">
            <i className="fas fa-check"></i>
          </div>
          
          <h1 className="confirmation-title">
            Bank Account Information Submitted
          </h1>
          
          <p className="confirmation-message">
            Thank you! Our team will review your business information before enabling Stripe payouts.
          </p>

          <p className="confirmation-message" style={{ marginTop: 15 }}>
          In the meantime, please enable Zelle or Venmo payment methods for immediate setup.
          </p>
        </div>
      </section>

      <style jsx>{`
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-tap-highlight-color: transparent;
        }

        html {
            scroll-behavior: smooth;
        }

        :root {
            /* Core colors */
            --bg-primary: #0A0A0F;
            --bg-secondary: #14121E;
            --bg-tertiary: #1A1825;
            
            /* Surface colors */
            --surface: rgba(255,255,255,0.03);
            --surface-light: rgba(255,255,255,0.05);
            --surface-border: rgba(255,255,255,0.08);
            
            /* Text colors */
            --text-primary: #FFFFFF;
            --text-secondary: rgba(255,255,255,0.7);
            --text-tertiary: rgba(255,255,255,0.5);
            --text-muted: rgba(255,255,255,0.6);
            
            /* Accent colors */
            --success: #4CFF50;
            
            /* Gradients */
            --gradient-primary: linear-gradient(135deg, #833AB4, #FD1D1D, #FCB045);
            --gradient-success: linear-gradient(135deg, #4CFF50, #00D68F);
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Lato', Roboto, 'Helvetica Neue', Arial, sans-serif;
            background: var(--bg-primary);
            color: var(--text-primary);
            overflow-x: hidden;
            line-height: 1.6;
        }

        /* Background */
        .background {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, #0A0A0F 0%, #14121E 50%, #1A1825 100%);
            z-index: -2;
        }

        /* Gradient orbs */
        .orb {
            position: fixed;
            border-radius: 50%;
            opacity: 0.1;
            z-index: -1;
            pointer-events: none;
        }

        .orb1 {
            width: 600px;
            height: 600px;
            background: radial-gradient(circle at center, rgba(76, 255, 80, 0.2) 0%, transparent 70%);
            top: -200px;
            right: -200px;
        }

        .orb2 {
            width: 500px;
            height: 500px;
            background: radial-gradient(circle at center, rgba(252, 176, 69, 0.2) 0%, transparent 70%);
            bottom: -200px;
            left: -200px;
        }

        /* Navigation */
        nav {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            padding: 20px 40px;
            background: rgba(20, 18, 30, 0.95);
            border-bottom: 1px solid rgba(255,255,255,0.05);
            z-index: 1000;
        }

        .nav-container {
            max-width: 1400px;
            margin: 0 auto;
            display: flex;
            align-items: center;
        }

        .logo {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 28px;
            font-weight: 800;
            letter-spacing: -1px;
            cursor: pointer;
        }

        .logo-icon {
            width: 44px;
            height: 44px;
            background: var(--gradient-primary);
            border-radius: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 16px rgba(131, 58, 180, 0.2);
        }

        .logo-icon i {
            font-size: 22px;
            color: white;
        }

        .logo-text {
            color: #FFFFFF;
        }

        /* Confirmation Section */
        .confirmation-section {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 120px 40px 60px;
        }

        .confirmation-card {
            max-width: 500px;
            width: 100%;
            background: var(--surface);
            border: 1px solid rgba(255,255,255,0.08);
            border-radius: 24px;
            padding: 56px;
            text-align: center;
            position: relative;
            overflow: hidden;
            opacity: 0;
            animation: cardFadeIn 0.6s ease-out forwards;
            animation-delay: 0.2s;
        }

        @keyframes cardFadeIn {
            to {
                opacity: 1;
                transform: translateY(0);
            }
            from {
                opacity: 0;
                transform: translateY(20px);
            }
        }

        /* Success Icon */
        .success-icon {
            width: 100px;
            height: 100px;
            margin: 0 auto 28px;
            background: #6be5a1;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            opacity: 0;
            transform: scale(0);
            transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .success-icon.animate {
            opacity: 1;
            transform: scale(1);
        }

        .success-icon::before {
            content: '';
            position: absolute;
            inset: -2px;
            border-radius: 50%;
            background: var(--gradient-success);
            opacity: 0.3;
            animation: pulse 2s infinite;
        }

        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
                opacity: 0.3;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.1;
            }
        }

        .success-icon i {
            font-size: 40px;
            color: black;
            position: relative;
            z-index: 1;
        }

        /* Typography */
        .confirmation-title {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 20px;
            letter-spacing: -0.5px;
            line-height: 1.2;
            color: var(--text-primary);
        }

        .confirmation-message {
            font-size: 16px;
            color: var(--text-secondary);
            line-height: 1.6;
            letter-spacing: 0.3px;
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
            nav {
                padding: 16px 24px;
            }

            .confirmation-section {
                padding: 100px 24px 40px;
            }

            .confirmation-card {
                padding: 48px 32px;
            }

            .success-icon {
                width: 100px;
                height: 100px;
            }

            .success-icon i {
                font-size: 40px;
            }

            .confirmation-title {
                font-size: 28px;
            }

            .confirmation-message {
                font-size: 16px;
            }

            .action-buttons {
                flex-direction: column;
            }

            .refresh-button, .dashboard-button {
                width: 100%;
                justify-content: center;
            }
        }

        @media (max-width: 480px) {
            .confirmation-card {
                padding: 40px 24px;
                border-radius: 24px;
            }

            .confirmation-title {
                font-size: 24px;
            }
        }
      `}</style>
      
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />
    </div>
  );
};

export default StripeBankConfirm;